import { APP_VERSION } from "@/constants/normal";
import { getServeConfig } from "@/stores/useEnvConfigStore";
import { initDayjs } from "@/utils/dayjs";
import { initAttribute } from "./browser";
import { initFingerprint } from "./fingerprint";
import { initI18n } from "./i18n";

export const initApp = async () => {
  const { defaultLocale, area, timezone } = getServeConfig();
  const waitInitI18n = initI18n(defaultLocale, area);

  console.log("[Live Version]", APP_VERSION);

  initAttribute();
  initFingerprint();
  initDayjs(timezone);

  await waitInitI18n;
};
